export const getConnectedSavodTier = (savodCollection, tierId) => {
	const connectedSavodTier =
		savodCollection.find((savodTier) =>
			tierId.includes('WITH_ADS') ? savodTier.id === tierId : savodTier.id === `${tierId}_WITH_ADS`
		) ?? undefined;
	let savodTier = undefined;

	if (connectedSavodTier) {
		savodTier = {
			id: connectedSavodTier.id,
			price: connectedSavodTier.pricing.recurring,
			label: 'met reclame',
		};
	}
	return savodTier;
};
